import React, { useMemo, useState } from "react";
import { FORUM_CATEGORIES, forumApi } from "../../utils/forumApi";
import {
  Button,
  FieldGrid,
  FieldGroup,
  Form,
  FormCard,
  HelperText,
  HiddenField,
  Input,
  Notice,
  Select,
  Textarea,
} from "./ForumStyles";

const initialValues = {
  title: "",
  body: "",
  authorName: "",
  authorEmail: "",
  category: "General",
  honeypot: "",
};

function AskForm() {
  const renderedAt = useMemo(() => Date.now(), []);
  const [values, setValues] = useState(initialValues);
  const [status, setStatus] = useState({ type: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus({ type: "", message: "" });
    setIsSubmitting(true);

    try {
      const response = await forumApi.submitQuestion({
        ...values,
        renderedAt,
      });

      setStatus({
        type: "success",
        message:
          response?.message ||
          "Your question has been submitted and is waiting for admin review.",
      });
      setValues(initialValues);
    } catch (error) {
      setStatus({
        type: "error",
        message:
          error instanceof Error
            ? error.message
            : "Could not submit your question. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <FormCard>
      <Form onSubmit={handleSubmit}>
        {status.message ? (
          <Notice $type={status.type === "error" ? "error" : "success"}>
            {status.message}
          </Notice>
        ) : null}

        <FieldGroup>
          Question Title
          <Input
            type="text"
            name="title"
            value={values.title}
            onChange={handleChange}
            placeholder="Summarize your question clearly"
            minLength={10}
            maxLength={160}
            required
          />
        </FieldGroup>

        <FieldGroup>
          Details
          <Textarea
            name="body"
            value={values.body}
            onChange={handleChange}
            placeholder="Explain the problem, context, and what you have tried so far."
            minLength={30}
            maxLength={5000}
            required
          />
        </FieldGroup>

        <FieldGrid>
          <FieldGroup>
            Your Name
            <Input
              type="text"
              name="authorName"
              value={values.authorName}
              onChange={handleChange}
              placeholder="Your name"
            />
          </FieldGroup>

          <FieldGroup>
            Email Address
            <Input
              type="email"
              name="authorEmail"
              value={values.authorEmail}
              onChange={handleChange}
              placeholder="your@email.com"
            />
          </FieldGroup>
        </FieldGrid>

        <FieldGroup>
          Category
          <Select name="category" value={values.category} onChange={handleChange}>
            {FORUM_CATEGORIES.map((category) => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </Select>
        </FieldGroup>

        <HiddenField
          type="text"
          name="honeypot"
          value={values.honeypot}
          onChange={handleChange}
          tabIndex="-1"
          autoComplete="off"
        />

        <HelperText>
          Every question goes through admin review before it appears publicly. Please
          keep your question technical and specific.
        </HelperText>

        <Button type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Submitting..." : "Submit Question"}
        </Button>
      </Form>
    </FormCard>
  );
}

export default AskForm;
